export default new class FormDataChangeHelper {

  /**
   *
   * @return boolean
   * @param formRef
   * @param id
   * @param originalValues
   */
  changed (formRef, id = null, originalValues = null) {
    if (!formRef) {
      return false
    }

    let formValues         = formRef.getValues().getValues(),
        formOriginalValues = originalValues
          ? originalValues
          : formRef.getOriginalValues()

    for (let i = 0; i < formValues.length; i++) {
      let formValue         = formValues[i],
          formOriginalValue = formOriginalValues.getValueItem(formValue.key),
          isPasswordField   = formValue.key.indexOf('PASSWORD')

      if (!formOriginalValue && !id) {
        return true
      }

      if (!formOriginalValue && !isPasswordField) {
        continue
      }
      if (!formOriginalValue && isPasswordField) {
        formOriginalValue = { value: null }
      }

      let formValueV         = formValue.value
      let formOriginalValueV = formOriginalValue.value

      if (formValue.value === '') {
        formValueV = null
      }

      if (formOriginalValue.value === '') {
        formOriginalValueV = null
      }

      if (typeof formValueV === 'string') {
        formValueV = formValueV.toLowerCase()
        formValueV = formValueV.replaceAll('\\/', '/')
      }

      if (typeof formOriginalValueV === 'string') {
        formOriginalValueV = formOriginalValueV.toLowerCase()
        formOriginalValueV = formOriginalValueV.replaceAll('\\/', '/')
      }

      if (formValueV !== formOriginalValueV) {
        return true
      }
    }

    return false
  }

}
